import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const ITEMS = ['Confirm USPS delivery requirements', 'Match the post, finish, size, and mounting type', 'Check house numbers and personalization', 'Verify replacement-part compatibility', 'Ask about installation before checkout'];
export function Checklist() {
  return <section className="py-16 bg-brand-card border-t border-brand-border" data-id="element-109">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-110">
        <h2 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal mb-8" data-id="element-111">
          Before you order, make sure the fit is right
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-left" data-id="element-112">
          {ITEMS.map((item, index) => <div key={index} className="bg-white p-4 rounded-lg border border-brand-border shadow-sm flex items-start gap-3" data-id="element-113">
              <CheckCircle2 className="text-brand-green shrink-0 mt-0.5" size={20} data-id="element-114" />
              <span className="text-sm font-medium text-gray-700 leading-snug" data-id="element-115">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}